import Dashboard from "../views/Dashboard";
import Profile from "../views/Profile";
import Settings from "../views/Settings";
import EditProfile from "@/views/EditProfile";
import PurchaseHistory from "@/views/PurchaseHistory";
import Notification from "@/views/Notification";
import LeaderBoard from "@/views/LeaderBoard";
import Store from "@/views/Store";
import Friends from "@/views/Friends";
import FindFriends from "@/views/FindFriends";
import SelectFriend from "@/views/SelectFriend";

import Challenge from "@/views/Challenge";

export default [
    {
        path: "/",
        name: "/",
        redirect: "/login",
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/challenge-list",
        name: "Challenge",
        component: Challenge,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/edit-profile",
        name: "EditProfile",
        component: EditProfile,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/purchase-history",
        name: "PurchaseHistory",
        component: PurchaseHistory,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/settings",
        name: "Settings",
        component: Settings,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/notifications",
        name: "Notification",
        component: Notification,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/leaderboard",
        name: "Leaderboard",
        component: LeaderBoard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/store",
        name: "Store",
        component: Store,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/friends",
        name: "Friends",
        component: Friends,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/select-friends",
        name: "SelectFriend",
        component: SelectFriend,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/find-friends",
        name: "FindFriends",
        component: FindFriends,
        meta: {
            requiresAuth: true
        }
    },

];
